export const assetTypes = { VIDEO: "video", SUBTITLE: "subtitle" };
